import { render, staticRenderFns } from "./UploadDocument.vue?vue&type=template&id=328a666a&scoped=true"
import script from "./UploadDocument.vue?vue&type=script&lang=ts"
export * from "./UploadDocument.vue?vue&type=script&lang=ts"
import style0 from "./UploadDocument.vue?vue&type=style&index=0&id=328a666a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "328a666a",
  null
  
)

export default component.exports